export default "__VITE_ASSET__bf474be5__"